<template>
  <svg
    :width="props.width"
    :height="props.height"
    viewBox="0 0 734 251"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="advanz">
      <g id="Group">
        <g id="Group_2">
          <path
            id="Vector"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M733.824 45.0399H632.543V71.9786H680.749L622.801 167.399H727.492V140.461H676.203L733.824 45.0399Z"
            :fill="props.fill"
          />
          <path
            id="Vector_2"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M520.15 167.399V92.5879L578.907 167.399H610.556V45.0399H578.907V119.852L520.15 45.0399H488.338V167.399H520.15Z"
            :fill="props.fill"
          />
          <path
            id="Vector_3"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M243.906 45.0399L295.358 167.399H320.678L372.292 45.0399H337.72L308.017 119.527L278.478 45.0399H243.906Z"
            :fill="props.fill"
          />
          <path
            id="Vector_4"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M214.067 119.933C212.499 124.099 210.226 127.695 207.25 130.724C204.274 133.756 200.622 136.135 196.294 137.865C191.966 139.597 187.044 140.461 181.523 140.461H174.221V71.9786H181.523C186.933 71.9786 191.804 72.8464 196.132 74.5743C200.458 76.306 204.111 78.6875 207.09 81.7151C210.062 84.7466 212.364 88.3695 213.987 92.5879C215.61 96.8062 216.42 101.351 216.42 106.218C216.42 111.197 215.636 115.769 214.067 119.933ZM244.988 82.9312C241.847 75.5218 237.546 69.0309 232.086 63.4583C226.617 57.8876 220.236 53.4241 212.933 50.0677C205.627 46.7191 197.81 45.0399 189.477 45.0399H142.407V167.399H189.477C197.917 167.399 205.79 165.724 213.094 162.368C220.396 159.019 226.781 154.527 232.245 148.901C237.708 143.274 241.985 136.756 245.068 129.345C248.152 121.935 249.696 114.228 249.696 106.218C249.696 98.106 248.123 90.3444 244.988 82.9312Z"
            :fill="props.fill"
          />
          <path
            id="Vector_5"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M50.2182 121.961L64.5023 81.2267L78.7845 121.961H50.2182ZM81.869 45.0399H47.1337L0.55072 167.399H34.4745L41.78 146.14H87.2245L94.5301 167.399H128.452L81.869 45.0399Z"
            :fill="props.fill"
          />
        </g>
        <g id="Group_3">
          <path
            id="Vector_6"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M411.811 1.50793L343.408 167.495H407.51L420.329 136.326H391.941L413.336 85.124L479.619 251L479.436 173.507L411.811 1.50793Z"
            :fill="props.fill"
          />
          <path
            id="Vector_7"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.65137 214.998H18.4954C20.0931 214.998 21.6636 214.813 23.2049 214.442C24.7462 214.072 26.1162 213.473 27.315 212.644C28.5137 211.817 29.4829 210.717 30.2263 209.348C30.9677 207.978 31.3394 206.297 31.3394 204.297C31.3394 202.357 30.9541 200.701 30.1835 199.331C29.4128 197.961 28.4145 196.835 27.1865 195.949C25.9586 195.066 24.5457 194.424 22.948 194.023C21.3483 193.624 19.7506 193.424 18.1529 193.424H5.65137V214.998ZM0 188.287H17.4679C19.5794 188.287 21.792 188.53 24.104 189.015C26.4159 189.501 28.5274 190.342 30.4403 191.54C32.3514 192.739 33.9219 194.381 35.1498 196.463C36.3758 198.547 36.9908 201.158 36.9908 204.297C36.9908 207.036 36.4907 209.404 35.4923 211.402C34.494 213.401 33.1512 215.041 31.4679 216.325C29.7826 217.609 27.8424 218.565 25.6452 219.193C23.4462 219.822 21.1498 220.135 18.7523 220.135H5.65137V248.901H0V188.287Z"
            :fill="props.fill"
          />
          <path
            id="Vector_8"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M60.2813 188.287H65.9307V214.998H99.8409V188.287H105.49V248.901H99.8409V220.135H65.9307V248.901H60.2813V188.287Z"
            :fill="props.fill"
          />
          <path
            id="Vector_9"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M154.469 194.451L140.34 227.669H168.169L154.469 194.451ZM151.814 188.287H157.637L183.154 248.901H176.818L170.224 232.805H138.114L131.264 248.901H125.356L151.814 188.287Z"
            :fill="props.fill"
          />
          <path
            id="Vector_10"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M208.585 214.998H220.573C223.541 214.998 225.952 214.628 227.808 213.885C229.663 213.144 231.105 212.229 232.132 211.145C233.16 210.062 233.857 208.892 234.23 207.635C234.6 206.38 234.787 205.238 234.787 204.211C234.787 203.184 234.6 202.043 234.23 200.786C233.857 199.531 233.16 198.36 232.132 197.276C231.105 196.193 229.663 195.278 227.808 194.537C225.952 193.795 223.541 193.424 220.573 193.424H208.585V214.998ZM202.934 188.287H218.86C219.658 188.287 220.744 188.316 222.114 188.373C223.484 188.431 224.967 188.602 226.567 188.886C228.164 189.172 229.791 189.628 231.447 190.256C233.102 190.886 234.585 191.797 235.9 192.996C237.212 194.194 238.298 195.706 239.154 197.533C240.01 199.36 240.438 201.588 240.438 204.211C240.438 207.122 239.936 209.519 238.94 211.402C237.94 213.286 236.684 214.813 235.172 215.983C233.658 217.154 231.988 218.024 230.163 218.594C228.336 219.166 226.594 219.565 224.94 219.792L242.579 248.901H236.157L219.117 220.135H208.585V248.901H202.934V188.287Z"
            :fill="props.fill"
          />
          <path
            id="Vector_11"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M264.241 188.287H272.718L294.809 239.141L316.901 188.287H324.95V248.901H319.299V195.478H319.127L296.008 248.901H293.525L270.063 195.478H269.892V248.901H264.241V188.287Z"
            :fill="props.fill"
          />
          <path
            id="Vector_12"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M373.329 194.451L359.201 227.669H387.03L373.329 194.451ZM370.675 188.287H376.497L402.014 248.901H395.678L389.085 232.805H356.974L350.124 248.901H344.216L370.675 188.287Z"
            :fill="props.fill"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script setup lang="ts">
const props = defineProps({
  width: {
    type: [Number, String],
    default: 734
  },
  height: {
    type: [Number, String],
    default: 251
  },
  fill: {
    type: String,
    default: '#ffffff'
  }
})
</script>
